import { fsDateUtils } from './fsDateUtils';

/**
 * Filter to format a date according to the settings
 */
/** @ngInject */
export function fsDateCalendarFilter($cookies, userService) {
    return htmlCode => fsDateUtils.toString(htmlCode, userService, $cookies,
            format => format.substring(0, format.indexOf(' ')),true); // keep only date format, scrap time
}
